module.exports = __webpack_public_path__ + "wordtracker-logo-90d5a713a649a21d49cd6e3887b51bc8.png";